const CartMonogram = (function() {
  const updateMonogram = (lineItemId, properties, quantity) => {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineItemId,
        quantity,
        properties
      })
    })
  }

  const showMonogramInput = (e) => {
    e.preventDefault()
    const id = e.target.dataset.id
    const mv = document.getElementById(`monogram-view-${id}`)
    if (mv) {
      mv.classList.add('hidden')
    }
    const mi = document.getElementById(`monogram-input-${id}`)
    if (mi) {
      mi.classList.remove('hidden')
      const input = mi.querySelector('.monogram-input')
      if (input) {
        input.focus()
        input.select()
      }
    }
  }

  const onMonogramInputSubmit = (e) => {
    e.preventDefault()

    if (e.target.form.reportValidity && !e.target.form.reportValidity()) {
      return false
    }

    const key = e.target.dataset.key
    const idKey = key.replace(':', '_')
    const quantity = e.target.dataset.quantity
    const monogram = document.querySelector(`#monogram-input-${idKey} .monogram-input`).value.toUpperCase()
    const first = monogram.charAt(0)
    let middle, last
    if (e.target.dataset.straight === 'true') {
      middle = monogram.charAt(1)
      last = monogram.charAt(2)
    } else {
      last = monogram.charAt(1)
      middle = monogram.charAt(2)
    }

    // Get existing properties, then overwrite the initials with our new values.
    const properties = {}
    const propertiesElement = document.getElementById(`monogram-properties-${idKey}`)
    if (propertiesElement) {
      const propArray = JSON.parse(propertiesElement.text)
      propArray.forEach((pair) => { properties[pair[0]] = pair[1] })
    }
    properties['First Name Initial'] = first
    properties['Middle Name Initial'] = middle
    properties['Last Name Initial'] = last

    updateMonogram(key, properties, quantity).then(() => {
      let config = document.getElementById('cart-config')
      if ( !config ) document.location.reload()
      config = JSON.parse(config.innerHTML || '{}')
      window.Shopify.theme.cart.getCart().then(Cart => { window.Shopify.theme.ajaxCart.updateView(config, Cart) })
    })
  }

  const onMonogramInputCancel = (e) => {
    const id = e.target.dataset.id
    const mi = document.getElementById(`monogram-input-${id}`)
    if (mi) {
      mi.classList.add('hidden')
    }
    const mv = document.getElementById(`monogram-view-${id}`)
    if (mv) {
      mv.classList.remove('hidden')
    }
  }

  return {
    initialize() {
      document.addEventListener('click', (e) => {
        const classes = e.target.classList
        if (classes.contains('monogram-add-button')) {
          showMonogramInput(e)
        } else if (classes.contains('monogram-input-submit')) {
          onMonogramInputSubmit(e)
        } else if (classes.contains('monogram-input-cancel')) {
          onMonogramInputCancel(e)
        }
      })
    }
  }
})()

export default CartMonogram
